import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';

import { Box } from '../Box';
import { Text } from '../Text';

export const NoOverflowBox = styled(Box)`
  overflow: hidden;
  position: relative;
  z-index: 0;
`;

export const ImageWrapper = styled('div')<{ isMobile?: boolean }>`
  & > span {
    display: ${({ isMobile = false }) =>
      isMobile ? 'block' : 'none'} !important;

    ${mediaQueries.tablet} {
      display: ${({ isMobile = false }) =>
        isMobile ? 'none' : 'block'} !important;
    }
  }
`;

export const HeroText = styled('div')`
  text-align: center;
  margin: auto;

  ${mediaQueries.tablet} {
    text-align: left;
    position: absolute;
    z-index: 1;
    top: 40%;
    transform: translate(0, -40%);
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const DesktopHeading = styled(Text)`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const MobileHeading = styled(Text)`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopCopyWrapper = styled('div')`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const MobileCopyWrapper = styled('div')`
  ${mediaQueries.tablet} {
    display: none;
  }
`;
